module.exports = __webpack_public_path__ + "static/media/ABoyPic.bd0ec0f2.svg";